import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Mark from './Mark';
import './Footer.css';

const COLS = [
  {
    title: 'Around here',
    links: [
      { to: '/',            label: 'Home' },
      { to: '/noticeboard', label: 'Noticeboard' },
      { to: '/about',       label: 'About & committee' },
      { to: '/map',         label: 'Area map' },
    ],
  },
  {
    title: 'Get involved',
    links: [
      { to: '/join',    label: 'Join CWARA' },
      { to: '/contact', label: 'Contact us' },
      { to: '/privacy', label: 'Privacy policy' },
    ],
  },
];

export default function Footer() {
  const year = new Date().getFullYear();
  const navigate = useNavigate();

  return (
    <footer className="site-footer">
      <div className="footer-inner wrap">
        <div className="footer-brand">
          <Link to="/" className="brand footer-brand-link">
            <Mark size={34} />
            <span className="brand-text">
              <span className="brand-name" style={{ color: 'var(--paper)' }}>CWARA</span>
              <span className="brand-sub" style={{ color: 'rgba(244,236,221,0.6)' }}>Est. for our neighbours</span>
            </span>
          </Link>
          <p className="footer-note">
            A volunteer-run residents association for the Carlisle &amp; Waverley area of
            St&nbsp;Albans. Free to join if you live within the boundary.
          </p>
        </div>

        {COLS.map(({ title, links }) => (
          <div className="footer-col" key={title}>
            <h4>{title}</h4>
            {links.map(({ to, label }) => (
              <Link key={label} to={to} className="footer-link">{label}</Link>
            ))}
          </div>
        ))}

        <div className="footer-col">
          <h4>Stay in touch</h4>
          <p className="footer-note">
            Most of what we do happens by email. Join and we'll keep you posted.
          </p>
          <button
            className="btn btn-sm footer-cta"
            onClick={() => navigate('/join')}
          >
            Get the updates
          </button>
        </div>
      </div>

      <div className="footer-base wrap">
        <span>© {year} Carlisle and Waverley Area Residents Association</span>
        <span className="footer-mono">made by neighbours, for neighbours</span>
      </div>
    </footer>
  );
}
